const notificationTypes = [
  { name: "Push", value: "push" },
  { name: "SMS", value: "sms" },
  // { name: "Email", value: "email" },
];

export { notificationTypes };
